<script setup>
import { useNotifier } from '@daysmart/daysmart-vue-components/composables'

const { alerts } = useSessionData()
const notifier = useNotifier()

const { errorsBus } = useErrorsBus()
const { t } = useI18n()
errorsBus.on((error = {}) => {
  const { type, message } = error
  switch (type) {
    case 'form':
      notifier.emit({
        type: 'danger',
        title: t('An Error Occurred'),
        content: message || t('Please review the form and try submitting again'),
      })
      break
    case 'http':
    default:
      notifier.emit({
        type: 'danger',
        title: t('An Error Occurred'),
        content: message || t('Please try again later'),
      })
      break
  }
})

onMounted(() => {
  alerts.forEach((alert) => {
    notifier.emit({ type: alert.level === 'success' ? 'success' : 'danger', content: alert.body })
  })
})
</script>

<template />

<i18n>
{
  "en-us": {
    "An Error Occurred": "An Error Occured",
    "Please try again later": "Please try again later",
    "Please review the form and try submitting again": "Please review the form and try submitting again"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "An Error Occurred": "Ein Fehler ist aufgetreten",
  "Please try again later": "Bitte später erneut versuchen",
  "Please review the form and try submitting again": "Bitte überprüfen Sie das Formular und senden Sie es erneut."
}
</i18n>

<i18n locale="fr" lang="json">
{
  "An Error Occurred": "Une erreur est survenue",
  "Please try again later": "Veuillez réessayer plus tard",
  "Please review the form and try submitting again": "Veuillez examiner le formulaire et tenter un nouvel envoi"
}
</i18n>

<i18n locale="es" lang="json">
{
  "An Error Occurred": "Ha habido un error",
  "Please try again later": "Vuelve a intentarlo más tarde",
  "Please review the form and try submitting again": "Revisa el formulario e intenta enviarlo de nuevo"
}
</i18n>
